<label [class.sr-only]="!label" [for]="inputId">{{ label || ariaLabel || placeholder || 'Select options' }}</label>
<ng-select [items]="items" [bindLabel]="bindLabel" [bindValue]="bindValue" [formControl]="ktSelect" [labelForId]="inputId"
    [multiple]="multiple" [closeOnSelect]="closeOnSelect" [hideSelected]="hideSelected" [placeholder]="placeholder" clearAllText="Clear selection"
    [appendTo]="appendTo" (blur)="onBlur()" (close)="valueChangeEmit()"
    (clear)="valueChangeEmit()" [ngClass]="{'remove-border': withoutBorder, 'single-row': singleRow}"
    [ngStyle]="{width: width}" [virtualScroll]="virtualScroll">
    @if(multiple) {
    <ng-template ng-header-tmp>
        <mat-checkbox class="kt-multi-select small-checkbox ia-select-all" (change)="toggleSelectAll()"
            [checked]="allSelected" [indeterminate]="partiallySelected" [disabled]="ktSelect.disabled || !items?.length">
            <span class="ia-select-all__text">Select all</span>
        </mat-checkbox>
    </ng-template>
    <ng-template ng-option-tmp let-item="item" let-index="index" let-item$="item$">
        <div class="ia-select-option">
            <mat-checkbox class="kt-multi-select small-checkbox ia-select-option__check" [checked]="item$.selected"
                [tabIndex]="-1" aria-hidden="true"></mat-checkbox>
            <span class="ia-select-option__label">
                @if (showColorDot) {
                <span class="d-inline-block tag-static mr-2"
                    [style.background-color]="(colorField && item) ? item[colorField] : null"></span>
                }
                {{bindLabel ? item[bindLabel] : item}}
            </span>
        </div>
    </ng-template>
    @if(maxVisibleSelected) {
    <ng-template ng-multi-label-tmp let-items="items">
        <div class="ng-value" *ngFor="let item of (items | slice : 0 : maxVisibleSelected)">
            <button type="button" class="ng-value-icon left ia-select-remove" [disabled]="ktSelect.disabled"
                [attr.aria-label]="'Remove ' + (bindLabel ? item[bindLabel] : item)"
                (keydown.enter)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()"
                (click)="$event.stopPropagation(); deselect(item)"><span aria-hidden="true">&times;</span></button>
            <span class="ng-value-label">{{ bindLabel ? item[bindLabel] : item }}</span>
        </div>
        <div class="ng-value" *ngIf="items.length > maxVisibleSelected">
            <span class="ng-value-label">+{{items.length - maxVisibleSelected}} more</span>
        </div>
    </ng-template>
    }
    }
</ng-select>
